// state/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoaderOpen: false,
  isSidebarMenuOpen: false,
  isCommentOpen: false,
  currentActiveCardIndex: null,
  selectedVideo: null,
  isPlayerModalOpen: false,
  hasInteracted: false, // new flag
  playerState: {
    currentTime: 0,
    isPlaying: false,
    volume: 1,
    isFullscreen: false,
  },
  scrollY: 0,
};

const sliceSlice = createSlice({
  name: "videoSlice",
  initialState,
  reducers: {
    setHasInteracted: (state, action) => {
      state.hasInteracted = action.payload; // true/false
    },
    openLoader: (state) => {
      state.isLoaderOpen = true;
      document.body.classList.add("modal-open");
    },
    closeLoader: (state) => {
      state.isLoaderOpen = false;
      document.body.classList.remove("modal-open"); // Re-enable scrolling
    },
    openComment: (state) => {
      state.isCommentOpen = true;
      document.body.classList.add("comment-modal-open"); // Disable scroll
    },
    closeComment: (state) => {
      state.isCommentOpen = false;
      document.body.classList.remove("comment-modal-open"); // Re-enable scrolling
    },
    openPlayerModal: (state) => {
      state.isPlayerModalOpen = true;
      document.body.classList.add("player-modal-open"); // Disable scroll
    },
    closePlayerModal: (state) => {
      state.isPlayerModalOpen = false;
      document.body.classList.remove("player-modal-open"); // Re-enable scrolling
    },
    // The current playing video
    handleCurrentPlayVideo: (state, action) => {
      state.loading = false;
      state.selectedVideo = action.payload;
    },

    openSidebarMenu: (state) => {
      state.isSidebarMenuOpen = true;
      document.body.classList.add("menu-open"); // Disable scroll
    },
    closeSidebarMenu: (state) => {
      state.isSidebarMenuOpen = false;
      document.body.classList.remove("menu-open"); // Re-enable scrolling
    },

    //this hook + slice to also preserve player state + scroll position. That way when autoplay navigates to the next video, your WatchPage doesn’t reset.
    savePlayerState: (state, action) => {
      state.playerState = { ...state.playerState, ...action.payload };
    },
    saveScrollY: (state, action) => {
      state.scrollY = action.payload;
    },
  },
});

// Export actions
export const {
  openLoader,
  closeLoader,
  handleCurrentPlayVideo,
  openComment,
  closeComment,
  openPlayerModal,
  closePlayerModal,
  openSidebarMenu,
  closeSidebarMenu,
  setHasInteracted,
  savePlayerState,
  saveScrollY,
} = sliceSlice.actions;

// Export the reducer
export default sliceSlice.reducer;
